'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    var inputs = $(context).find('[data-binding="radio-item"]').prev();

    function init() {

        $('body').on('click', '[data-binding="radio-item"]', function (e) {
            e.preventDefault();

            var input = $(this).prev();
            inputs.removeClass('focus');

            if (!$(input).prop('checked')) {
                $(input).prop('checked', true).addClass('focus');
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/radio-list.js
// module id = 231
// module chunks = 0